module.exports = __webpack_public_path__ + "static/media/clients-02.c06a8ba2.svg";